export load from './load';
export resizeFile from './resizeFile';



// WEBPACK FOOTER //
// ./src/Utils/Images/index.js